module.exports = __webpack_public_path__ + "media/Audio18_f.1b08676f.wav";